<template>
    <span v-if="hasContent">
        <div>
            <p>{{columnPreview}}</p>
            <r-button v-if="requiresModal" type="link" @click="showModal">{{andMore}}</r-button>
        </div>
        <v-modal :title="modalTitle" v-if="isModalVisible" @close="closeModal">
            <template slot="content">
                 <div class="table-control">
                    <table class="table table-hoverable">
                        <thead>
                            <tr>
                                <th>{{setTitle}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in tableContent">
                                <td>{{row}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <template slot="actions">
                <r-button type="primary" @click="closeModal">Close</r-button>
            </template>
        </v-modal>
    </span>
    <span v-else-if="emptyEventsFilter">
        <p>All events</p>
    </span>
    <span v-else>
        <p>–</p>
    </span>
</template>

<script>
    import _ from '@/common/helpers';
    import vModal from '@/components/modal/v-modal';

    export default {
        name: 'webhook-modal',
        components: {
            vModal,
        },
        props: {
            entry: {
                type: Object,
            },
            limit: {
                type: Number,
            },
            name: {
                type: String,
            },
        },
        data() {
            return {
                isModalVisible: false,
            };
        },
        computed: {
            andMore() {
                if (this.requiresModal) {
                    const rest = this.columnNbItem - this.limit;
                    return `and ${rest} more.`;
                }
                return ``;
            },
            columnNbItem() {
                if (this.entry.fields) {
                    return this.entry.fields[this.name].length;
                }
                return 0;
            },
            columnPreview() {
                const mapper = this.isFirstItemObject
                    ? item => `${item.name}: ${item.value}`
                    : event => _.unKebabCase(event);
                return this.entry.fields[this.name]
                    .slice(0, this.limit)
                    .map(mapper)
                    .join(', ');
            },
            emptyEventsFilter() {
                return !this.hasContent && this.name === 'eventsFilter';
            },
            hasContent() {
                return this.columnNbItem !== 0;
            },
            isFirstItemObject() {
                const [firstItem] = this.entry.fields[this.name];
                return firstItem && (typeof firstItem === 'object');
            },
            modalTitle() {
                return `${_.capitalize(this.name)} List`;
            },
            tableContent() {
                const mapper = this.isFirstItemObject
                    ? item => `${item.name}: ${item.value}`
                    : event => _.unKebabCase(event);
                return this.entry.fields[this.name]
                    .map(mapper);
            },
            requiresModal() {
                return this.columnNbItem > this.limit;
            },
            setTitle() {
                if (this.name === 'headers') {
                    return 'Headers (Key: Value)';
                } if (this.name === 'eventsFilter') {
                    return 'Events Filter';
                }
                return '';
            },
        },
        methods: {
            showModal() {
                if (this.requiresModal) {
                    this.isModalVisible = true;
                }
            },
            closeModal() {
                this.isModalVisible = false;
            },
        },
    };
</script>
